import {FrameDto, OrderDto, SectionFragmentType} from "@hec/api-dtos";
import {getSectionFragmentsFromOrderByType} from "./GetSectionFragmentsFromOrderByType";
import { createSelector } from '@reduxjs/toolkit';
import {DormerRootState} from "../../DormerRootState";

export const getConfiguredFramesFromOrder = (order: OrderDto): FrameDto[] => {
  return (getSectionFragmentsFromOrderByType(order, SectionFragmentType.Frame) as FrameDto[])
    .filter(frame => frame.faceId !== null && frame.orderId != null);
};

export const getConfiguredFramesFromOrderSelector = createSelector(
  [(state: DormerRootState) => state.order.order],
  (order): FrameDto[] => {
    if (!order) return [];
    return getConfiguredFramesFromOrder(order);
  }
);
